// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import LandingPage from './pages/LandingPage/LandingPage';
import LogIn from './components/RoleSelection';
import ProtectedRoute from './components/ProtectedRoute';
import AccessDenied from './pages/AccessDenied';

import { CourierApp } from './pages/Courier/CourierApp';

import AdminDashboard from './components/AdminDashboard';
import DashboardLayout from './layouts/DashboardLayout';

import PackagesPage from './pages/Admin/Packages/PackagesPage';
import CouriersListPage from './pages/Admin/Couriers/CouriersListPage';
import CourierPerformancePage from './pages/Admin/Couriers/CourierPerformancePage';
import WarehousesPage from './pages/Admin/Warehouses/WarehousesPage';
import VehiclesPage from './pages/Admin/Vehicles/VehiclesPage';
import AnalyticsPage from './pages/Admin/Analytics/AnalyticsPage';
import { MyProfilePage } from './pages/Admin/Profile/MyProfilePage';
import SettingsPage from './pages/Admin/Settings/SettingsPage';
import AdminsPage from './pages/Admin/Admins/AdminsPage';
import { ContactCourier } from './pages/Admin/Couriers/ContactCourier/ContactCourier';
import NotificationsPage from './pages/Admin/Notifications/NotificationsPage';

import TrackingPage from './pages/orders/TrackingPage';

function App() {
  return (
      <Router>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LogIn />} />
          <Route path="/access-denied" element={<AccessDenied />} />

          {/* Tracking public route */}
          <Route path="/track/:trackingId?" element={<TrackingPage />} />

          {/* Courier protected route */}
          <Route element={<ProtectedRoute allowedRoles={['courier']} />}>
            <Route path="/courier" element={<CourierApp />} />
          </Route>

          {/* Admin protected routes */}
          <Route element={<ProtectedRoute allowedRoles={['admin', 'master admin']} />}>
            <Route path="/admin" element={<DashboardLayout />}>
              <Route index element={<AdminDashboard />} />

              <Route path="packages" element={<PackagesPage />} />
              <Route path="notifications" element={<NotificationsPage />} />

              <Route path="couriers" element={<CouriersListPage />} />
              <Route path="couriers/performance" element={<CourierPerformancePage />} />
              <Route path="couriers/:courierId/contact" element={<ContactCourier />} />

              <Route path="warehouses" element={<WarehousesPage />} />
              <Route path="vehicles" element={<VehiclesPage />} />
              <Route path="analytics" element={<AnalyticsPage />} />
              <Route path="profile" element={<MyProfilePage />} />
              <Route path="settings" element={<SettingsPage />} />
              <Route path="admins" element={<AdminsPage />} />
            </Route>
          </Route>

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
  );
}

export default App;